import React, { useContext, useState } from "react";
import { CSSTransition } from "react-transition-group";
import classNames from "classnames";

import CatalogItem from "../catalog-item/CatalogItem.jsx";
import { GlobalContext } from "../../globals/globalContext.jsx";
import { MOBILE_BREAKPOINT } from "../../util/constants.js";
import "./subcategory.css";

function shouldDisplaySubcategoryHeading(name, subcategoryCount) {
  return name !== "undefined" && subcategoryCount !== 1;
}

function Subcategory(props) {
  const {
    products,
    name,
    subcategoryCount,
    editable,
    allow_ordering_before_suggestions_at,
    onChange,
    categoryId,
    items_deliver_listings,
    reRender,
    isGrid,
    ownerlessShop,
    listRef,
    delivery,
    setVisibleItemId,
    visibleItemId,
  } = props;

  if (!products.length) {
    return null;
  }

  const [openedId, setOpenedId] = useState(null);
  const [latestRow, setLatestRow] = useState(0);
  const { windowWidth, onFavouriteAddRemove } = useContext(GlobalContext);
  const isDesktop = windowWidth > MOBILE_BREAKPOINT;

  const handleClick = (openedId) => setOpenedId(openedId);
  const handleVisibleItem = (id) => setVisibleItemId(id);

  function getMatchedItemFromCart(CatalogItemId) {
    if (!delivery) return [];
    const foundItem = delivery.orders.filter(
      (order) => order.id === CatalogItemId && !order.display_silently_in_cart,
    );
    return foundItem;
  }

  products.sort((a, b) => {
    const textA = a.article.name.toUpperCase();
    const textB = b.article.name.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  });

  function calculateShowQtInCatalog(matchedCartItem) {
    if (!matchedCartItem || matchedCartItem?.display_silently_in_cart) return 0;

    let showQtInCatalog = 0;
    if (matchedCartItem) {
      const { num_portions_in_cart } = matchedCartItem;
      showQtInCatalog = num_portions_in_cart ?? 0;
    }
    return showQtInCatalog;
  }

  const productsList = products.map((product, index) => {
    const deliver_listing = product.deliver_listing || product;
    const { id } = deliver_listing;
    const matchedCartItem = getMatchedItemFromCart(
      product.matched_cart_item_id,
    )?.[0];
    const isPacked = matchedCartItem?.is_packed;
    const showQtInCatalog = calculateShowQtInCatalog(matchedCartItem);
    const isItemOpen = id === visibleItemId;

    return (
      <CSSTransition key={product.id} timeout={400} classNames="fade">
        <CatalogItem
          index={index}
          key={product.id}
          productId={id}
          editable={editable}
          allow_ordering_before_suggestions_at={
            allow_ordering_before_suggestions_at
          }
          item={product}
          isPacked={isPacked}
          onChange={onChange}
          handleClick={handleClick}
          openedId={openedId}
          onFavouriteAddRemove={onFavouriteAddRemove}
          name={name}
          categoryId={categoryId}
          items_deliver_listings={items_deliver_listings}
          showQtInCatalog={showQtInCatalog}
          getMatchedItemFromCart={getMatchedItemFromCart}
          reRender={reRender}
          isGrid={isGrid}
          isItemOpen={isItemOpen}
          visibleItemId={visibleItemId}
          handleVisibleItem={handleVisibleItem}
          latestRow={latestRow}
          setLatestRow={setLatestRow}
          isDesktop={isDesktop}
          listRef={listRef}
          delivery={delivery}
          ownerlessShop={ownerlessShop}
        />
      </CSSTransition>
    );
  });

  const isDisplaySubCatHeading = shouldDisplaySubcategoryHeading(
    name,
    subcategoryCount,
  );
  return (
    <>
      <div
        data-category-title={name}
        style={{ paddingRight: "5px", paddingLeft: "5px" }}
      >
        {isDisplaySubCatHeading && <label>{name}</label>}
      </div>
      <div
        className={classNames("subcategory", {
          "subcategory-grid": isGrid || isDesktop,
          "grid-five": isDesktop,
        })}
        ref={listRef}
      >
        {productsList}
      </div>
    </>
  );
}
export default Subcategory;
